module.exports = __webpack_public_path__ + "HKGrotesk-Regular.6a5c78fe629996baf1b5.woff2";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/assets/fonts/HKGrotesk-Regular.woff2
// module id = ../../../../../src/assets/fonts/HKGrotesk-Regular.woff2
// module chunks = styles